import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { setCurrentEventId } from '../../redux/slice/events/eventsSlice';

const TableRow = ({ events, event_type }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    return (
        <>
            <div className='hidden lg:block bg-[#fff] text-[#000] mb-[7px]'>
                <table className='w-full game-list-col'>
                    <tbody>
                        {
                            events.length > 0 && (
                                <tr>
                                    <td className='eventInfo py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold'></td>
                                    <td className="col-visit py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold">1</td>
                                    <td className="col-draw py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold">x</td>
                                    <td className="col-home py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold">2</td>
                                    <td className="col-info py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-center w-[20px] text-[#000] font-bold"></td>
                                </tr>
                            )}
                        {
                            events?.map((event, index) => (
                                <tr key={index} className='table-row '>
                                    <td className='eventInfo py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold'>
                                        <div className="event-title"
                                            onClick={() => {
                                                navigate(`/event/${event?.event_type}/${event?.event_id}`)
                                                dispatch(setCurrentEventId(event?.event_id))
                                            }}
                                        >
                                            <span className="dtime ">{new Date(event?.open_date).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                hour12: false
                                            }).replace(',', '')} |</span>
                                            {
                                                event?.is_inplay !== 'False' && <span className="lvnow"></span>
                                            }
                                            {event?.event_name}
                                        </div>
                                        {
                                            event?.is_inplay !== 'False' && <div className="livenow ml-[.5rem] livenownew">Live Now</div>
                                        }
                                        <div className="float-right flex h-full mt-[.2rem]">
                                            {
                                                event?.is_tv == 'True' &&
                                                <span className="l-tv flex">
                                                    <img className='h-full mr-[2px]' alt="TV" src="/assets/svg/tv.svg" />
                                                </span>
                                            }
                                            {
                                                event?.is_bookmaker == 'True' &&
                                                <span className="l-tv flex">
                                                    <img className='h-full mr-[2px]' alt="TV" src="/assets/svg/bm-icon1.svg" />
                                                </span>
                                            }
                                            {
                                                event?.is_fancy == 'True' &&
                                                <div className='fancy1 flex items-center  mr-[.25rem]'>
                                                    <img className='h-full' alt="Fancy" src="/assets/svg/fancy-icon1.svg" />
                                                </div>
                                            }

                                        </div>
                                    </td>

                                    <td className="col-home py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold">
                                        {/* <div className="text-[#000] font-bold suspended-full"> */}
                                        <div className="text-[#000] font-bold ">
                                            <a id="btnBack0" className="btn-back" side="Back">
                                                <div className='text-[#000] font-bold min-h-[13px]'>3.1</div>
                                            </a>
                                            <a id="btnLay0" className="btn-lay" side="Lay">
                                                <div className='text-[#000] font-bold min-h-[13px]'>1.4</div>
                                            </a>
                                        </div>
                                    </td>

                                    <td className="col-draw py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold">
                                        <div className="">
                                            <a id="btnBack2" className="btn-back" side="Back">
                                                <div className='text-[#000] font-bold min-h-[13px]'>2</div>
                                            </a>
                                            <a id="btnLay2" className="btn-lay" side="Lay">
                                                <div className='text-[#000] font-bold min-h-[13px]'>0</div>
                                            </a>
                                        </div>
                                    </td>

                                    <td className="col-visit py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold">
                                        <div className="">
                                            <a id="btnBack1" className="btn-back" side="Back">
                                                <div className='text-[#000] font-bold min-h-[13px]'>2.3</div>
                                            </a>
                                            <a id="btnLay1" className="btn-lay" side="Lay">
                                                <div className='text-[#000] font-bold min-h-[13px]'>3</div>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        }
                        {
                            ['/', '/home'].includes(window.location.pathname) &&
                            <tr>
                                <td colSpan="5" className='py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold '>
                                    <a href={`/game/${event_type}`} className="viewmore cursor-pointer !float-right !pr-[5px] text-right text-[#000] font-bold" title="view more" >View More...</a>
                                </td>
                            </tr>
                        }
                        {
                            (events?.length === 0 || !events) && (
                                <tr>
                                    <td colSpan="5" className='py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold '>
                                        has no live event.
                                    </td>
                                </tr>
                            )
                        }

                    </tbody>
                </table>

            </div >

            <div className='block lg:hidden mobile-table-row bg-[#fff]'>
                {
                    events?.map((event, index) => (
                        <>
                            <div key={index} className='w-full pt-1' onClick={() => navigate(`/event/${event?.event_type}/${event?.event_id}`)}>
                                <div className="meventtitle" >
                                    {
                                        event?.is_inplay == 'True' &&
                                        <span className="lvnow"></span>
                                    }
                                    {event?.event_name}
                                </div>
                                {
                                    event?.is_inplay == 'True' && <div className="livenow ml-[.5rem] livenownew">Live Now</div>
                                }
                                <div className="flex gap-1 float-right">
                                    {
                                        event?.is_tv == 'True' &&
                                        <span className="l-tv">
                                            <img alt="" src="/assets/svg/tv.svg" />
                                        </span>
                                    }
                                    {
                                        event?.is_bookmaker == 'True' &&
                                        <span className="bm1">
                                            <img alt="" src="/assets/svg/bm-icon1.svg" />
                                        </span>
                                    }
                                    {
                                        event?.is_fancy == 'True' &&
                                        <span className="fancy1 mr-1">
                                            <img alt="" src="/assets/svg/fancy-icon1.svg" />
                                        </span>
                                    }
                                </div>
                            </div>
                            <div className='w-full block'>
                                <div className="mtitle text-[#545454]">
                                    <span><i className="flaticon-clock"></i> <span>{new Date(event?.open_date).toLocaleDateString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: false
                                    }).replace(',', '')}</span> | Ford Trophy</span>
                                </div>
                                <div className="col-info inline-flex text-center w-[20px] mr-1 float-right">
                                    <a className="bg-[url(https://images.staticcontent.io/rde/uimg/a-pin-mobile.svg)] !bg-contain border-[1px] border-solid border-[#7e97a7] rounded-[3px] h-[19px] w-[19px] cursor-pointer" title="Add to Multi Markets" ></a>
                                </div>
                            </div>
                            <table className='w-full game-list-col mb-1 text-[#212529] border-collapse'>
                                <tbody>
                                    <tr className='w-full'>
                                        <td className="text-[#000] font-bold py-[2px] px-[1px] w-[33%] text-center">
                                            {/* <div className="suspended-full"> */}
                                            <div className="">
                                                <a id="btnBack0" className="btn-back" side="Back">
                                                    <div className='text-[#000] font-bold min-h-[13px]'>2</div>
                                                </a>
                                                <a id="btnLay0" className="btn-lay" side="Lay">
                                                    <div className='text-[#000] font-bold min-h-[13px]'>0</div>
                                                </a>
                                            </div>
                                        </td>
                                        <td className="text-[#000] font-bold py-[2px] px-[1px] w-[33%] text-center">
                                            <div className="">
                                                <a id="btnBack2" className="btn-back" side="Back">
                                                    <div className='text-[#000] font-bold min-h-[13px]'>2.3</div>
                                                </a>
                                                <a id="btnLay2" className="btn-lay" side="Lay">
                                                    <div className='text-[#000] font-bold min-h-[13px]'>3</div>
                                                </a>
                                            </div>
                                        </td>
                                        <td className="text-[#000] font-bold py-[2px] px-[1px] w-[33%] text-center">
                                            <div className="">
                                                <a id="btnBack1" className="btn-back" side="Back">
                                                    <div className='text-[#000] font-bold min-h-[13px]'>3.1</div>
                                                </a>
                                                <a id="btnLay1" className="btn-lay" side="Lay">
                                                    <div className='text-[#000] font-bold min-h-[13px]'>1.4</div>
                                                </a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="border-solid border-b-[2px] border-[#cdcdcd] w-full"></div>
                        </>
                    ))
                }

                {
                    ['/', '/home'].includes(window.location.pathname) &&
                    events?.length > 0 &&
                    <div className="bg-[#fff] h-[23px] w-full">
                        <a href={`/game/${event_type}`} className="text-[#000] float-right pr-[5px] text-right cursor-pointer" title="view more" >View More...</a>
                    </div>
                }
                {
                    (events?.length === 0 || !events) && (
                        <tr>
                            <td colSpan="5" className='py-[2px] px-[1px] border-t-[1px] border-[#dee2e6] text-[#000] font-bold '>
                                has no live event.
                            </td>
                        </tr>
                    )
                }

            </div>
        </>
    );
};

export default TableRow;
